define(
    'viewmodels/secured/account/change',[
        "durandal/app",
        "viewmodels/ViewModelNotification",
        "providers/dataprovider",
        "plugins/router",
        "services/session",
        "i19n!i19n/strings",
        "services/service.dialog"
    ],
    function (app, ViewModelNotification, dataProvider, router, session, i19n, dialogService) {
        var _storageGauge = null;

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            
            personId: '',
            oldpassword: ko.observable('').extend({ required: true }),
            newpassword: ko.observable('').extend({ required: true }),
            confirmpassword: ko.observable('').extend({ required: true }),
            visible: ko.observable(true),
            messageVisible: ko.observable(false),
            message: ko.observable(''),
            show: function () {
                vm.visible(true);
                vm.messageVisible(false);
            },

            usersinuser: ko.observable(),            

            usage_total: ko.observable(0),
            subsMaxStorageLimit: 100,

            isAdmin: ko.observable(false),
            isInstanceAdmin: ko.observable(false),
            isCustomerTrial: ko.observable(true),
            isShowSubscription: ko.observable(false),
            version: ko.observable(''),
            expiryDate: ko.observable('_'),
            instanceId: window.fileplan.instanceCode,
            isOldClient: false
        });

        vm.activate = function () {
            $('#oldpassword').val('');
            $('#newpassword').val('');
            $('#confirmpassword').val('');

            vm.isOldClient = false;
            vm.personId = vm.session.user().userId();

            vm.notifications([]);
            vm.isAdmin(vm.session.role == 3 || vm.session.role == 4 ? true : false);
            vm.isInstanceAdmin(vm.session.role == 4 ? true : false);

            if (vm.isInstanceAdmin()) {
                vm.isShowSubscription(!(vm.session.isCustomerTrial == -1));
                vm.isCustomerTrial(vm.session.isCustomerTrial == -1 ? true : vm.session.isCustomerTrial);
            }

            //if (window.fileplan && window.fileplan.instanceCode && window.fileplan.instanceCode == "rollie") {
            //    vm.isCustomerTrial(false);
            //    vm.isShowSubscription(true);
            //}
            

            //vm.version(String.format(i19n.to.todownloadthefileplanclientforwindows78learnmore, requirejs.s.contexts._.config.urlArgs.replace("version=", "")));
            //vm.version(requirejs.s.contexts._.config.urlArgs.replace("version=", ""));
            vm.version(window.fileplan.version.replace("version=", ""));
           
            return dataProvider.persons
            .getPersons()
            .done(function (data) {
                var psum = { activeGuest: 0, activeUsers: 0 };

                _.map(data, function (itm) {
                    if (itm.personType == 1) {
                        psum.activeGuest++;
                    }
                    if (itm.personType != 1 && itm.personType != 0) {
                        psum.activeUsers++;
                    }
                });

                if (vm.isCustomerTrial())
                    vm.usersinuser(String.format(i19n.to._usersinuse_guestsinuse, psum.activeUsers, psum.activeGuest));
                else
                    vm.usersinuser(String.format(i19n.to._usersinuseof_available, psum.activeUsers, "_", psum.activeGuest, "_"));

                //vm.expiryDate(kendo.toString(kendo.parseDate('2015-05-26T22:00:00Z'), 'dd-MMM-yy hh:mm tt'));

                dataProvider.subscription
                .getCustomerSubs()
                .done(function (subs) {
                    vm.subsMaxStorageLimit = subs.subsMaxStorageLimit;
                    vm.isOldClient = subs.subsPlanCode == "fileplan_starter_aud" && !vm.isCustomerTrial();
                    if (subs.subsExpiryDate) {
                        vm.expiryDate(kendo.toString(kendo.parseDate(subs.subsExpiryDate), 'dd-MMM-yy hh:mm tt'));
                    }

                    if (vm.isCustomerTrial())
                        vm.usersinuser(String.format(i19n.to._usersinuse_guestsinuse, psum.activeUsers, psum.activeGuest));
                    else
                        vm.usersinuser(String.format(i19n.to._usersinuseof_available, psum.activeUsers, subs.subsMaxUserCount, psum.activeGuest, subs.subsMaxGuestCount));                    
                })
                .fail(function (e) {
                    e.stopPropagation = true;

                    console.error(e);
                })
                .always(function () {
                    setStorageUsage();
                });
            })
            .fail(function (e) {
                console.error(e);
            });            
        };
        vm.attached = function () {
            if ($('a#___subscriptionlink').length == 0) {
                var link = document.createElement('a');

                link.setAttribute('target', '_blank');
                link.setAttribute('id', '___subscriptionlink');

                document.body.appendChild(link);
            }
            
            vm.confirmpassword.extend({ validation: { validator: mustMatchPassword, message: i19n.to.passwordsdonotmatch } });

            _storageGauge = $("#account-gauge-storage").kendoProgressBar({
                type: "value",
                animation: false,
                change: function (e) {
                    this.progressWrapper.css({
                        "background-image": "none",
                        "border-image": "none"
                    });

                    var p = (e.value / this.options.max) * 100;
                    if (p > 89) {
                        this.progressWrapper.css({
                            "background-color": "#cc0033",
                            "border-color": "#cc0033"
                        });
                    } else {
                        this.progressWrapper.css({
                            "background-color": "#2b72ae",
                            "border-color": "#2b72ae"
                        });
                    }
                    
                    if (e.value > 0)
                        this.progressStatus.text(e.value + " GB of " + this.options.max + " GB used");
                    else
                        this.progressStatus.text(this.options.max + " GB available");
                }
            }).data("kendoProgressBar");

            setStorageUsage();
        };
        vm.close = function () {
            router.navigate("explorer");
        };

        vm.errors = ko.validation.group(vm);
        vm.isValid = ko.computed(function () {
            return vm.errors().length == 0;
        });

        vm.changePassword = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                if (vm.isValid()) {
                    var oldpassword = vm.oldpassword();
                    var newpassword = vm.confirmpassword();

                    dataProvider.accounts
                    .changePassword(vm.personId, oldpassword, newpassword)
                    .done(function () {
                        vm.notify('success', i19n.to.passwordupdated);

                        setTimeout(function () {
                            router.navigate("#logout");

                            complete();
                        }, 1000);
                    })
                    .fail(function (e) {
                        e.stopPropagation = true;
                        vm.notify(e);

                        complete();
                    });

                } else {
                    vm.errors.showAllMessages();
                    complete();
                }
            },
        });

        vm.manageSubscription = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting && vm.isShowSubscription();
            },
            execute: function (complete) {
                sessionStorage.navto = "account";
                
                if (vm.isOldClient)
                    router.navigate("#plan/1");
                else
                    router.navigate("#pricing/1");

                complete();
            }
        });
        vm.manageAccount = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting && vm.isShowSubscription();
            },
            execute: function (complete) {
                //also in people, explorer, account, settings
                dataProvider.subscription
                .getOrCreateSessionPortal({ redirectUrl: 'www.fileplanapp.com', instanceId: window.fileplan.instanceCode })
                .done(function (data) {
                    //$('a#___subscriptionlink')[0].setAttribute('href', data.accessUrl);
                    //$('a#___subscriptionlink')[0].click();

                    window.location.replace(data.accessUrl);
                })
                .fail(function (e) {
                    e.stopPropagation = true;

                    vm.notify(e.error);

                    console.error(e);
                })
                .always(complete);
            }
        });
        vm.enterPayment = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting && vm.isShowSubscription();
            },
            execute: function (complete) {
                
                router.navigate("#pricing/0");

                complete();
            }
        });
        vm.cancelTrial = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting && vm.isShowSubscription();
            },
            execute: function (complete) {
                dialogService.showDialog("modals/secured/account/CancelTrialModal")
                .then(function (dialogResult) {
                    if (dialogResult.cancelTrial) {
                        //router.navigate("#logout?iscanceltrial=1");
                        //complete();

                        dataProvider.subscription
                        .cancelSubscription()
                        .done(function (d) {
                            router.navigate("#logout?iscanceltrial=1");
                        })
                        .always(function () {
                            complete();
                        });                        
                    } else {
                        complete();
                    }
                });
            }
        });

        return vm;

        function setStorageUsage() {
            if (!_storageGauge)
                return;
            
            _storageGauge.options.max = 100;
            _storageGauge.value(1);
            _storageGauge.value(0);
            //_storageGauge.progressStatus.text("");

            dataProvider.settings
            .getUsageSetting()
            .done(function (storage) {
                _storageGauge.options.max = vm.subsMaxStorageLimit;
                _storageGauge.value(storage.totalSpaceUsedMB / 1024);

                var i = storage.totalSpaceUsedMB / 1024;
                var p = (i / _storageGauge.options.max) * 100;
                p = kendo.toString(p, 'n');
                vm.usage_total(p);
            })
            .fail(function (e) {
                e.stopPropagation = true;

                console.error(e);
            });
        }

        function mustMatchPassword(d) {
            return d == vm.newpassword();
        }
    }
);
